// extracted by mini-css-extract-plugin
export var author = "blogPost-module--author--52ab5";
export var body = "blogPost-module--body--5dfac";
export var container = "blogPost-module--container--48d70";
export var featureImage = "blogPost-module--featureImage--82ee2";
export var header = "blogPost-module--header--5b33e";
export var publishedAt = "blogPost-module--publishedAt--5aaae";
export var section = "blogPost-module--section--3a892";
export var subhead = "blogPost-module--subhead--0b737";